import React from 'react'
import { generatePath, Link } from 'react-router-dom'
import { IconButton, Whisper, Tooltip } from 'rsuite'
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine'
import { GQL_ID } from '@@partner:types:graphql'
import { 
  ROUTE_MARKETING_BANNER_EDIT, 
  ROUTE_MARKETING_BANNER_TYPE_EDIT,
  ROUTE_PRODUCT_GROUPS_EDIT,
  ROUTE_CATALOG_CATEGORY_EDIT,
  ROUTE_TEXT_MATERIALS_EDIT,
  ROUTE_SETTINGS_MENUS_EDIT
} from '@@partner:config/routes'

type EntityLinkProps = {
  entityId: GQL_ID | null | undefined
  entityType: 'banner' | 'bannerType' | 'productGroup' | 'category' | 'textMaterial' | 'menu'
  brandSlug: string
  tooltip?: string
}

const routeMap = {
  banner: ROUTE_MARKETING_BANNER_EDIT,
  bannerType: ROUTE_MARKETING_BANNER_TYPE_EDIT,
  productGroup: ROUTE_PRODUCT_GROUPS_EDIT,
  category: ROUTE_CATALOG_CATEGORY_EDIT,
  textMaterial: ROUTE_TEXT_MATERIALS_EDIT,
  menu: ROUTE_SETTINGS_MENUS_EDIT,
}

const paramMap = {
  banner: 'bannerId',
  bannerType: 'bannerTypeId',
  productGroup: 'groupId',
  category: 'categoryId',
  textMaterial: 'textId',
  menu: 'menuId',
}

export default function EntityLink ({ 
  entityId, 
  entityType, 
  brandSlug,
  tooltip = 'Перейти к редактированию'
}: EntityLinkProps) {
  if (!entityId) {
    return null
  }

  const route = routeMap[entityType]
  const paramKey = paramMap[entityType]
  
  const path = generatePath(route, {
    brandSlug,
    [paramKey]: entityId
  })

  return (
    <Whisper
      placement="top"
      trigger="hover"
      speaker={<Tooltip>{tooltip}</Tooltip>}
    >
      <IconButton
        as={Link}
        to={path}
        target="_blank"
        icon={<ArrowRightLineIcon />}
        appearance="subtle"
        size="sm"
        style={{ marginLeft: 8 }}
      />
    </Whisper>
  )
}

type EntityLinksListProps = {
  entityIds: GQL_ID[] | null | undefined
  entityType: 'banner' | 'bannerType' | 'productGroup' | 'category' | 'textMaterial'
  brandSlug: string
  labels?: Record<GQL_ID, string>
}

export function EntityLinksList ({
  entityIds,
  entityType,
  brandSlug,
  labels
}: EntityLinksListProps) {
  if (!entityIds || entityIds.length === 0) {
    return null
  }

  const route = routeMap[entityType]
  const paramKey = paramMap[entityType]

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
      {entityIds.map((id) => {
        const path = generatePath(route, {
          brandSlug,
          [paramKey]: id
        })
        return (
          <Whisper
            key={id}
            placement="top"
            trigger="hover"
            speaker={<Tooltip>Перейти к редактированию</Tooltip>}
          >
            <IconButton
              as={Link}
              to={path}
              target="_blank"
              icon={<ArrowRightLineIcon />}
              appearance="subtle"
              size="xs"
            >
              {labels?.[id] || id}
            </IconButton>
          </Whisper>
        )
      })}
    </div>
  )
}
